var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3972 0.615234C17.4128 0.615234 18.2722 1.47461 18.2722 2.49023V16.2402C18.2722 17.2949 17.4128 18.1152 16.3972 18.1152H11.0066V12.1777H13.2722L13.7019 9.36523H11.0066V7.56836C11.0066 6.78711 11.3972 6.04492 12.6082 6.04492H13.8191V3.66211C13.8191 3.66211 12.7253 3.4668 11.6316 3.4668C9.44409 3.4668 7.99878 4.83398 7.99878 7.25586V9.36523H5.53784V12.1777H7.99878V18.1152H2.64722C1.59253 18.1152 0.772217 17.2949 0.772217 16.2402V2.49023C0.772217 1.47461 1.59253 0.615234 2.64722 0.615234H16.3972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7c161cfb47214c9f1533fc169a5f5531.svg";
export { ForwardRef as ReactComponent };